export default "__VITE_ASSET__c0972de3__"